import React from "react";
import styled from "styled-components";

function getStyleSizeButton(size) {
  switch (size) {
    case "normal":
      return "padding: 1rem 2rem;";
    case "large":
      return `
        padding: 1rem 5rem;
        text-transform: uppercase;
        font-weight: 600;
      `;
    default:
      return "padding: 1rem 2rem;";
  }
}

export const BaseButton = styled.button`
  border: 0;
  text-decoration: none;

  display: flex;
  align-items: center;
  gap: 8px;
  width: fit-content;

  margin: ${({ margin }) => margin || 0};
  padding: ${({ padding }) => padding || 0};

  cursor: pointer;
  transition: 0.2s;
  ${({ size }) => getStyleSizeButton(size)}
`;

export const ButtonPrimary = styled(BaseButton)`
  background-color: #2f9dd9;
  color: white;
  text-transform: uppercase;
  &:hover {
    background-color: #1c7aad;
  }
`;

export const Button = ({
  variant = "primary",
  size = "normal",
  as = "button",
  ...props
}) => {
  let ButtonType;
  switch (variant) {
    case "primary":
      ButtonType = ButtonPrimary;
      break;
    default:
      ButtonType = <div>Variant no found</div>;
  }
  return (
    <ButtonType as={as} size={size} {...props}>
      {props.children}
    </ButtonType>
  );
};
